import React, { useEffect, useState } from "react";
import { PublicRoutes, PrivateRoutes } from "./routes";
import firebase from "./firebase";
import Backdrop from "@material-ui/core/Backdrop";
import "./App.css";
import "./index.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import "antd/dist/antd.css"; // or 'antd/dist/antd.less'
import profileActions from "./redux/profile/actions";
import { useDispatch, useSelector } from "react-redux";
import "./api/axiosInstance"
import 'dotenv/config'
import {ToastContainer} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { css } from "@emotion/react";
import {BeatLoader} from "react-spinners";

function App() {
  const { globalLoading, currentUser } = useSelector((state) => ({
    globalLoading: state.profile.globalLoading,
    currentUser: state.profile.currentUser,
  }));

  let [color] = useState();

  const dispatch = useDispatch();
  useEffect(() => {
    if (firebase) {
      firebase.auth().onAuthStateChanged((user) => {
        if (user) {
          dispatch({ type: profileActions.GET_CURRENT_USER, payload: {
            uid: user.uid
          } });
        } else {
          // No user is signed in.
          dispatch({ type: profileActions.SET_STATE, payload: {globalLoading: false} });
        }
      });
    }
  }, [firebase]);

  const override = css`
  display: block;
  margin: 0 auto;
  border-color: purple;
  color: purple;
  `;


  return (
    <>

    {globalLoading ? (
        <Backdrop open={true}>
          <div className="beat-loader">
            <BeatLoader color={color} loading={globalLoading} css={override} size={30} color={"#7444C0"}  />
          </div>
        </Backdrop>
      ) : (
        <div className="App">
          {currentUser.uid ? <PrivateRoutes /> : <PublicRoutes />}
        </div>
      )}
        
        <ToastContainer
                  autoClose={2000}
                  newestOnTop={false}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                  limit={2}
                  style={{width:'400px'}}
                  />
    </>
  );
}

export default App;
